import React from 'react';
import { ToggleButton } from './Button/ToggleButton';

export const TimelineSwitch = ({ active, open }) => {
  if (!open) {
    return null;
  }
  return (
    <div>
      <div className="body flex items-center">
        <div className="mr2">Show Version History</div>
        <div>
          <ToggleButton
            value={active}
            initialValue={active}
            onChange={() => {
              let location = window.location.href;
              if (active) {
                location = location.replace('&timeline=1', '');
              } else {
                location = `${location}&timeline=1`;
              }
              // Reload window with new query. We don't use the native browser URLSearchParam
              // to create this, because it changes the sort order of the params, which breaks
              // our signature verification.
              window.location.href = location;
            }}
          />
        </div>
      </div>
    </div>
  );
};
